module.exports = __webpack_public_path__ + "img/sheaf-of-rice.5ef11b36.png";